import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import arrayMove from 'array-move';
import { Container, QuestionLabel } from '../styles';
import {
  ContainerRanking,
  Content,
  DropdownRanking,
  ItemLabel,
  SortableListRanking,
  Text,
  TextErrorRanking,
} from './styles';
import { DESCRIPTION_LABEL, ERROR_TEXT_RANKING, PLACEHOLDER_SELECT_RANKING } from './constants';

const RankingQuestionType = (props) => {
  const {
    questionOptions, label, errorField, onChange,
  } = props;

  const [orderedData, setOrderedData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const questionOptionsReplaced = questionOptions.map((option, indexOptions) => ({
    key: option.id,
    text: indexOptions + 1,
    value: option.label,
    order: option.order,
  }));

  const handleChangeRanking = useCallback((e, data, i) => {
    const selectedOptionIndex = questionOptionsReplaced.findIndex((option) => option.value === data.value.split('-')[0]);
    const questionOptionsReorder = !_.isEmpty(orderedData) ? orderedData : questionOptionsReplaced;
    const clone = _.cloneDeep(questionOptionsReorder);

    if (selectedOptionIndex !== -1 && clone[i]) {
      const newOptions = arrayMove(clone, i, selectedOptionIndex);
      setOrderedData(newOptions);

      const updatedOptions = newOptions.map((option, indexOp) => ({
        questionOptionId: option.key,
        order: indexOp,
      }));

      setSelectedOptions(updatedOptions);
      onChange(updatedOptions);
    }
  }, [onChange, orderedData, questionOptionsReplaced]);

  const buildContent = useCallback(() => {
    const array = !_.isEmpty(orderedData) ? orderedData : questionOptionsReplaced;
    return (
      array.map((item, i) => (
        <Content key={item.id}>
          <DropdownRanking
            onChange={(e, data) => handleChangeRanking(e, data, i)}
            selection
            placeholder={PLACEHOLDER_SELECT_RANKING}
            options={questionOptionsReplaced.map((option, indexReplaced) => ({
              ...option,
              value: `${option.value}-${indexReplaced}`,
            }))}
            error={errorField}
            value={selectedOptions.length === 0 ? undefined : `${questionOptionsReplaced[i].value}-${i}`}
          />
          <ItemLabel>
            {item.value}
          </ItemLabel>
        </Content>
      ))
    );
  }, [errorField, handleChangeRanking, orderedData, questionOptionsReplaced, selectedOptions.length]);

  const handleMoveElement = useCallback(({ oldIndex, newIndex }) => {
    const questionOptionsReorder = !_.isEmpty(orderedData) ? orderedData : questionOptionsReplaced;

    const clone = _.cloneDeep(questionOptionsReorder);
    if (clone[oldIndex]) {
      const newQuestionOptionsOrdering = arrayMove(clone, oldIndex, newIndex);
      setOrderedData(newQuestionOptionsOrdering);

      const updatedOptions = newQuestionOptionsOrdering.map((option, indexOp) => ({
        questionOptionId: option.key,
        order: indexOp,
      }));

      setSelectedOptions(updatedOptions);
      onChange(updatedOptions);
    }
  }, [onChange, orderedData, questionOptionsReplaced]);

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>
      <Text>{DESCRIPTION_LABEL}</Text>
      <ContainerRanking>
        <SortableListRanking
          items={buildContent()}
          onSortEnd={handleMoveElement}
          marginTop="1.2em"
          spaceRight="2em"
          lockAxis="y"
        />
      </ContainerRanking>

      {errorField && (
        <TextErrorRanking>
          {ERROR_TEXT_RANKING}
        </TextErrorRanking>
      )}

    </Container>
  );
};

RankingQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  errorField: PropTypes.bool,
  onChange: PropTypes.func,
};

RankingQuestionType.defaultProps = {
  errorField: false,
  onChange: () => { },
};

export default RankingQuestionType;
